import styled from 'styled-components';
import * as ContextMenu from '@radix-ui/react-context-menu';
import {
	BaseContent,
	BaseItem,
	MenuSeparator,
	MenuPortal,
	MenuShortcut,
	MenuTrigger,
} from '../Menu/style';
import { zIndex } from '../../../tokens';

interface ItemProps {
	disabled?: boolean;
	$isMobile?: boolean;
}

interface ShortcutProps {
	$isMobile?: boolean;
}

interface ContentProps {
	$isMobile?: boolean;
}

export const Item = styled(ContextMenu.Item)<ItemProps>`
	${BaseItem}
`;

export const Shortcut = styled(MenuShortcut)<ShortcutProps>``;

export const Separator = styled(ContextMenu.Separator)`
	${MenuSeparator}
`;

export const Trigger = styled(ContextMenu.Trigger)`
	${MenuTrigger}
`;

export const Root = styled(ContextMenu.Root)``;

export const Portal = styled(ContextMenu.Portal)`
	${MenuPortal}
`;

export const Content = styled(ContextMenu.Content)<ContentProps>`
	${BaseContent}/*	z-index: ${zIndex.contextMenu}; */
`;
